export default {
  // Page title and states
  'pages.accountB.generateLog.title': 'B Account Generate Log',
  'pages.accountB.generateLog.emptyText': 'No generate logs',
  'pages.accountB.generateLog.msg.queryFailed': 'Failed to query generate logs',
  'pages.accountB.generateLog.msg.detailFailed':
    'Failed to load generate log detail',
  'pages.accountB.generateLog.msg.retry': 'Retry',
  'pages.accountB.generateLog.msg.copy': 'Copy',
  'pages.accountB.generateLog.msg.copied': 'Copied',
  'pages.accountB.generateLog.tooltip.nameNotBackfilled':
    'Name not backfilled, fallback to ID',

  // Search area ("All" = no filter)
  'pages.accountB.generateLog.search.all': 'All',
  'pages.accountB.generateLog.search.tenant': 'Tenant',
  'pages.accountB.generateLog.search.tenant.placeholder': 'Select tenant',
  'pages.accountB.generateLog.search.store': 'Store',
  'pages.accountB.generateLog.search.store.placeholder': 'Select store',
  'pages.accountB.generateLog.search.store.placeholderFirst':
    'Select a tenant first',
  'pages.accountB.generateLog.search.pos': 'POS',
  'pages.accountB.generateLog.search.pos.placeholder': 'Select POS',
  'pages.accountB.generateLog.search.pos.placeholderFirst':
    'Select a store first',
  'pages.accountB.generateLog.search.status': 'Status',
  'pages.accountB.generateLog.search.triggerSource': 'Trigger Source',
  'pages.accountB.generateLog.search.createTimeRange': 'Created At',

  // List columns
  'pages.accountB.generateLog.column.id': 'Log ID',
  'pages.accountB.generateLog.column.configId': 'Config ID',
  'pages.accountB.generateLog.column.tenantName': 'Tenant',
  'pages.accountB.generateLog.column.storeName': 'Store',
  'pages.accountB.generateLog.column.pos': 'POS',
  'pages.accountB.generateLog.column.dateRange': 'Date Range',
  'pages.accountB.generateLog.column.triggerSource': 'Trigger Source',
  'pages.accountB.generateLog.column.forceParam': 'Force Recalc',
  'pages.accountB.generateLog.column.status': 'Status',
  'pages.accountB.generateLog.column.generatedDays': 'Generated Days',
  'pages.accountB.generateLog.column.failedDate': 'Failed Date',
  'pages.accountB.generateLog.column.duration': 'Duration (s)',
  'pages.accountB.generateLog.column.lockConflict': 'Lock Conflict',
  'pages.accountB.generateLog.column.createTime': 'Created At',
  'pages.accountB.generateLog.column.action': 'Actions',
  'pages.accountB.generateLog.action.detail': 'Detail',

  // Enum translations (unknown values shown as-is)
  'pages.accountB.generateLog.status.RUNNING': 'Running',
  'pages.accountB.generateLog.status.SUCCESS': 'Success',
  'pages.accountB.generateLog.status.FAILED': 'Failed',
  // Requirement deviation ruling: add a separate SKIPPED option for status
  // filter/display (skipped as a whole due to lock conflict, paired with lock_conflict=1)
  'pages.accountB.generateLog.status.SKIPPED': 'Lock conflict (skipped)',
  'pages.accountB.generateLog.trigger.MANUAL': 'Manual',
  'pages.accountB.generateLog.trigger.JOB': 'Scheduled Job',
  'pages.accountB.generateLog.trigger.BACKFILL': 'Backfill',
  'pages.accountB.generateLog.trigger.CLI': 'Command Line',
  'pages.accountB.generateLog.force.yes': 'Force recalc',
  'pages.accountB.generateLog.force.no': 'Regular',
  'pages.accountB.generateLog.lock.yes': 'Yes',
  'pages.accountB.generateLog.lock.no': 'No',

  // Detail modal
  'pages.accountB.generateLog.detail.title': 'Generate Log Detail',
  'pages.accountB.generateLog.detail.refresh': 'Refresh',
  'pages.accountB.generateLog.detail.close': 'Close',
  'pages.accountB.generateLog.detail.loading': 'Loading…',
  'pages.accountB.generateLog.detail.group.basic': 'Basic Info',
  'pages.accountB.generateLog.detail.group.params': 'Generation Params',
  'pages.accountB.generateLog.detail.group.caller': 'Caller Info',
  'pages.accountB.generateLog.detail.group.result': 'Result',
  'pages.accountB.generateLog.detail.group.skipFail': 'Skipped & Failed',
  'pages.accountB.generateLog.detail.group.time': 'Timestamps',
  'pages.accountB.generateLog.detail.id': 'Log ID',
  'pages.accountB.generateLog.detail.configId': 'Config ID',
  'pages.accountB.generateLog.detail.tenant': 'Tenant',
  'pages.accountB.generateLog.detail.store': 'Store',
  'pages.accountB.generateLog.detail.pos': 'POS',
  'pages.accountB.generateLog.detail.startDate': 'Start Date',
  'pages.accountB.generateLog.detail.endDate': 'End Date',
  'pages.accountB.generateLog.detail.forceParam': 'Force Recalc',
  'pages.accountB.generateLog.detail.triggerSource': 'Trigger Source',
  'pages.accountB.generateLog.detail.caller': 'Caller',
  'pages.accountB.generateLog.detail.callerIp': 'Caller IP',
  'pages.accountB.generateLog.detail.status': 'Status',
  'pages.accountB.generateLog.detail.generatedDays': 'Generated Days',
  'pages.accountB.generateLog.detail.duration': 'Duration (s)',
  'pages.accountB.generateLog.detail.lockConflict': 'Lock Conflict',
  'pages.accountB.generateLog.detail.skippedDays': 'Skipped Dates',
  'pages.accountB.generateLog.detail.failedDate': 'Failed Date',
  'pages.accountB.generateLog.detail.errorMsg': 'Error Message',
  'pages.accountB.generateLog.detail.createTime': 'Created At',
  'pages.accountB.generateLog.detail.updateTime': 'Updated At',
};
